import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  IconButton,
  Button,
  Select,
  Grid,
  Divider,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Input } from "src/components/common/FormComponents";
import { formHeaders } from "src/constants/sampleData";
// import { setProjectAreaDetails, setStep } from "src/redux/slices/newProjectSetup";
import { useAppSelector } from "src/redux/store";
import { getStyles } from "src/styles/theme";
import FormWrapper from "../FormWrapper";
// import { PlotAreaDetailsForm } from "../types";
import { setBaselineData, setStep } from "src/redux/slices/newProjectSetup";
import { PlotAreaDetailsForm } from "../newTypes";
import defaultStyles, { StylesClasses } from "./styles";
import errorMessage from "src/constants/errorMessage";
import React, { useState } from "react";

const formHeads = formHeaders["PlotAreaDetails"];

const ProjectBaselineData = () => {
  const { formData } = useAppSelector(
    (state) => state.root.selectNewProjectSetup
  );

  const { control, getValues, setValue, formState, watch, reset } =
    useForm<PlotAreaDetailsForm>({
      mode: "onTouched",
      defaultValues: formData.baselineData,
    });

  const dispatch = useDispatch();

  const { errors, isValid } = formState;
  const styles = getStyles<StylesClasses>(defaultStyles);

  //seedling
  const selectedValue = watch("presenceOfInvasiveSpecies");

  const [rows, setRows] = useState([
    { commonName: "", botanicalName: "", numberOfSeedlings: "" },
  ]);

  const handleChange = (index, field, value) => {
    // Prevent negative numbers for numberOfSeedlings field
    if (field === "numberOfSeedlings" && value.startsWith("-")) {
      return;
    }

    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      { commonName: "", botanicalName: "", numberOfSeedlings: "" },
    ]);
  };

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };
  React.useEffect(() => {
    setValue("seedlingDetails", rows);
  }, [rows, setValue]);

  return (
    <FormWrapper
      isValid={isValid}
      onNext={() => {
        const formValues = getValues();
        dispatch(setBaselineData(formValues));
        dispatch(setStep("ProjectImageForm"));
      }}
      onBack={() => {
        dispatch(setStep("ProjectDetails"));
      }}
      subHeading={formHeads.details}
      currentStepNumber={2}
      // showBackBtn={!!!projectData.id}
    >
      {/* <Typography variant="h6" component="h1">
        Soil Characteristics
      </Typography> */}

      <Typography variant="h6" component="h1">
        Edaphic Details
      </Typography>

      {/* <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="edaphicDetails"
          control={control}
          type="text"
          placeholder="(In 500 characters)"
          label="Edaphic Details"
          multiline
          minRows={3}
        />
      </Box> */}

      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="soilType"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="e.g. sandy, clayey, loamy, lateritic, etc."
          label="Soil Types"
          multiline
          minRows={1}
        />
      </Box>
      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="soilDepthAndTexture"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="field observation"
          label="Soil Depth and Texture"
          multiline
          minRows={1}
        />
      </Box>

      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="soilMoistureRegime"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="dry, moist, seasonal waterlogged, etc"
          label="Soil Moisture Regime"
          multiline
          minRows={1}
        />
      </Box>
      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="soilpH"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder=""
          label="Soil pH And fertility status"
          multiline
          minRows={1}
        />
      </Box>

      {/* <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          name="slopeAndTerrain"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="(In 500 characters)"
          label="Slope And Terrain"
          multiline
          minRows={3}
        />
      </Box> */}

      {/* <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          name="geologicalFeatures"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="(In 500 characters)"
          label="Geological Features"
          multiline
          minRows={3}
        />
      </Box> */}

      <Typography variant="h6" component="h1">
        Hydrological Conditions
      </Typography>

      {/* <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          name="hydrologicalConditions"
          control={control}
          type="text"
          placeholder="(In 500 characters)"
          label="Hydrological Conditions"
          multiline
          minRows={3}
        />
      </Box> */}

      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="sourceOfWater"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="e.g: natural storm, bore wells, tanks, etc."
          label="Source of Water"
          multiline
          minRows={1}
        />
      </Box>
      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="waterSupplyLines"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="number"
          placeholder="Average Ground water level (in meters) of nearest borewell in the reasons"
          label="Average Ground water level"
          multiline
          minRows={1}
        />
      </Box>
      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="distanceToNearestWaterSource"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder=""
          label="Distance to Nearest Water Source in kilometers"
          multiline
          minRows={1}
        />
      </Box>

      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="averagRainfall"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="number"
          placeholder="In milli meters"
          label="Average rainfall in the region"
          multiline
          minRows={1}
        />
      </Box>

      {/* <Typography variant="h6" component="h1">
        Flora & Fauna
      </Typography> */}

      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          name="forestType"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="(In 500 characters)"
          label="Forest Type"
          multiline
          minRows={3}
        />
      </Box>
      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="typeOfVegetation"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="e.g: scrup, grassland, regenerating forest, degraded plantation, etc."
          label="Type of Vegetation"
          multiline
          minRows={1}
        />
      </Box>

      {/* <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="dominantSpecies"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="local native species"
          label="Presence of existing trees inside Land parcel"
          multiline
          minRows={1}
        />
      </Box> */}

      <Box {...styles("input")}>
        <Typography sx={{ fontWeight: 600, mb: 1 }}>
          Presence of existing trees inside Land parcel
        </Typography>

        {/* Table headings */}
        <Grid container spacing={2} sx={{ mb: 1 }}>
          <Grid item xs={4}>
            <Typography>Common Name</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>Botanical Name</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>Number of Trees</Typography>
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>

        {/* Rows */}
        {rows.map((row, index) => (
          <Grid
            container
            spacing={2}
            alignItems="center"
            key={index}
            sx={{ mb: 1 }}
          >
            <Grid item xs={4}>
              <TextField
                fullWidth
                required
                placeholder="Enter Common Name"
                value={row.commonName}
                onChange={(e) =>
                  handleChange(index, "commonName", e.target.value)
                }
                error={!row.numberOfSeedlings}
                helperText={!row.numberOfSeedlings ? errorMessage.required : ""}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                placeholder="Enter Botanical Name"
                value={row.botanicalName}
                onChange={(e) =>
                  handleChange(index, "botanicalName", e.target.value)
                }
                error={!row.numberOfSeedlings}
                helperText={!row.numberOfSeedlings ? errorMessage.required : ""}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                required
                placeholder="Enter Number of Trees"
                value={row.numberOfSeedlings}
                onChange={(e) =>
                  handleChange(index, "numberOfSeedlings", e.target.value)
                }
                type="number"
                inputProps={{ min: "0" }}
                error={!row.numberOfSeedlings}
                helperText={!row.numberOfSeedlings ? errorMessage.required : ""}
              />
            </Grid>
            <Grid item xs={1}>
              {rows.length > 1 && (
                <IconButton
                  color="error"
                  onClick={() => handleDeleteRow(index)}
                >
                  <Delete />
                </IconButton>
              )}
            </Grid>
          </Grid>
        ))}

        {/* Add More Button */}
        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={handleAddRow}
          sx={{ mt: 1 }}
        >
          Add More
        </Button>
      </Box>

      <Box {...styles("input")}>
        {/* Label */}
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, mb: 1, pt: 2, color: "text.primary" }}
        >
          Presence of Invasive Species
        </Typography>

        {/* Dropdown */}
        <FormControl fullWidth>
          <Select
            id="presenceOfInvasiveSpecies"
            name="presenceOfInvasiveSpecies"
            value={selectedValue || "No"} // default is No
            displayEmpty
            onChange={(e) =>
              setValue("presenceOfInvasiveSpecies", e.target.value)
            }
            sx={{ backgroundColor: "#fff" }}
          >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </Select>
        </FormControl>

        {selectedValue === "Yes" && (
          <Box sx={{ mt: 2 }}>
            <Input
              customStyles={{
                label: defaultStyles.label,
                wrapper: defaultStyles.selectWrapper,
                input: defaultStyles.multilineInput,
              }}
              typeof="textarea"
              name="invasiveSpeciesDetails"
              rules={{
                required: errorMessage.required,
                maxLength: {
                  value: 500,
                  message: "More than 500 characters are not allowed",
                },
              }}
              control={control}
              type="text"
              placeholder="Enter details of invasive species"
              label="Invasive Species Details"
              multiline
              minRows={2}
            />
          </Box>
        )}
      </Box>

      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="existingFauna"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="list observed or known fauna"
          label="Existing Fauna (Native Animals, wildlife, birds etc)"
          multiline
          minRows={2}
        />
      </Box>
      <Typography variant="h6" component="h1">
        Socio-Environmental Context
      </Typography>
      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="soilCharacteristics"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="Settlements nearby"
          label="Name of the nearest village or habitation"
          multiline
          minRows={3}
        />
      </Box>

      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="proximityToLocalCommunities"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="Distance in KM"
          label="Distance to nearest habitation"
          multiline
          minRows={1}
        />
      </Box>

      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="rightsAndUsage"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="(In 500 characters)"
          label="Rights and Usage"
          multiline
          minRows={2}
        />
      </Box>
      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="communityDependency"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="(In 500 characters)"
          label="Community Dependency"
          multiline
          minRows={2}
        />
      </Box>
      <Box {...styles("input")}>
        <Input
          customStyles={{
            label: defaultStyles.label,
            wrapper: defaultStyles.selectWrapper,
            input: defaultStyles.multilineInput,
          }}
          typeof="textarea"
          name="anyExistingRestrictions"
          rules={{
            required: errorMessage.required,
            maxLength: {
              value: 500,
              message: "More then 500 characters are not allowed",
            },
          }}
          control={control}
          type="text"
          placeholder="(In 500 characters)"
          label="Any Existing Restrictions"
          multiline
          minRows={2}
        />
      </Box>
    </FormWrapper>
  );
};

export default ProjectBaselineData;
